import React from "react";
import { Link } from "react-router-dom";
import { Typography } from "antd";

const { Title, Text } = Typography;

export function PassChangedSuccess({ textColor }) {
    return (
        <div style={{ marginTop: "auto", marginBottom: "auto", paddingLeft: 40 }}>
            <Title style={{ ...textColor }}>Recuperar senha</Title>
            <Text style={{ ...textColor }}>
                Enviado email para recuperação de senha. Verifique na sua caixa de entrada!
            </Text>
            <br />
            <Link className="" to="/login">
                Voltar para login
            </Link>
        </div>
    );
}
